import { render, staticRenderFns } from "./InstructionsAndroid.vue?vue&type=template&id=539d854b&"
import script from "./InstructionsAndroid.vue?vue&type=script&lang=js&"
export * from "./InstructionsAndroid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports